import { Alert, AlertType, TAB_ALERTS } from 'app/modules/alerts/core/type';

import { formatDistanceToNow, isThisWeek, isToday, parseISO } from 'date-fns';
import { groupBy } from 'lodash';

export const groupAlertsByTime = (alerts: Alert[]) => {
  return groupBy(alerts, (alert) => {
    const date = parseISO(alert.createdAt);

    const timeGroups = [
      { check: isToday, label: 'Today' },
      { check: isThisWeek, label: 'This Week' },
    ];

    const matched = timeGroups.find(({ check }) => check(date));

    return matched?.label || formatDistanceToNow(date, { addSuffix: true });
  });
};

export const tabToQueryMap: Record<TAB_ALERTS, string> = {
  [TAB_ALERTS.ALL_TYPES]: 'all-types',
  [TAB_ALERTS.DEVICE_CONNECTION]: 'device-connection',
  [TAB_ALERTS.ITEM_EXPIRY]: 'item-expiry',
  [TAB_ALERTS.REACH_CRITICAL_LEVEL]: 'reach-critical-level',
  [TAB_ALERTS.ABNORMAL_CONSUMPTION]: 'abnormal-consumption',
};

export const queryToTabMap = Object.fromEntries(
  Object.entries(tabToQueryMap).map(([key, value]) => [value, Number(key)]),
);

export const getAlertKeyFromType = (type: AlertType) =>
  ({
    [AlertType['Rack Failed Connection']]: 'Rack Failed Connection',
    [AlertType['Reach Critical Level']]: 'Reach Critical Level',
    [AlertType['Abnormal Consumption']]: 'Abnormal Consumption',
    [AlertType['Shelf Expiry']]: 'Shelf Expiry',
  }[type]);
